<template>
  <div class="custom-table dropdown-table">
    <div class="custom-table__row --header">
      <div class="custom-table__cell">{{ $t('ci_cd.pipeline.pipelineStatus') }}</div>
      <div class="custom-table__cell">{{ $t('ci_cd.pipeline.pipelineConveyor') }}</div>
      <div class="custom-table__cell">{{ $t('ci_cd.pipeline.pipelineInitiator') }}</div>
      <div
        v-if="!isInRange"
        class="custom-table__cell"
      >
        {{ $t('ci_cd.pipeline.pipelineCommit') }}
      </div>
      <div class="custom-table__cell">{{ $t('ci_cd.pipeline.pipelineStages') }}</div>
      <div class="custom-table__cell"></div>
    </div>
    <pipeline-list-item
      v-for="item in pipelines.items"
      :key="item.id"
      :item="item"
      @restart="$emit('restart', item)"
      @cancel="$emit('cancel', item)"
      @delete="$emit('delete', item)"
    />
  </div>
</template>

<script>
import PipelineListItem from '@shared/modules/ci-cd/components/pipeline-list-item';
import CiCdMessages from '@shared/modules/ci-cd/ci-cd.messages';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
export default {
  name: 'CiCdPipelinesTable',
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    isInRange() {
      return this.windowWidth >= 992 && this.windowWidth <= 1400;
    }
  },
  components: {
    PipelineListItem
  },
  props: {
    pipelines: {
      default: null,
      type: Object
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  i18n: {
    messages: CiCdMessages
  }
};
</script>

<style lang="scss">
$this: '.custom-table';
$break_lg: 992px;
$break_xxl: 1400px;

#{$this} {
  display: grid;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  text-wrap: nowrap;

    #{$this}__row:first-child {
      #{$this}__cell {
        padding: 8px 0.875rem !important;
      }
    }

  #{$this}__row {
    display: grid;

    grid-template-columns:
      minmax(207px, 215px) minmax(100px, 200px) minmax(130px, 260px) minmax(230px, 476px)
      minmax(120px, 237px) 22px;

    @media screen and (min-width: #{$break_lg}) and (max-width: #{$break_xxl}) {
      grid-template-columns:
        minmax(207px, 215px) minmax(230px, 476px) minmax(130px, 260px) minmax(120px, 237px)
        22px;
    }

    @media screen and (min-width: #{$break_lg}) {
      padding: 0 1.5rem !important;

      &:not(:first-child) {
        grid-template-rows: auto;
      }

      &:not(:first-child) {
        border-top: 1px solid var(--border-color);
      }
    }

    .cell_job-id {
      display: flex;
      flex-wrap: wrap;
    }

    .cell_job-initiator {
      gap: 0.5rem;
    }

    @media screen and (max-width: #{$break_lg}) {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      border-top: none;
      padding: 0.875rem;

      &:not(:last-child) {
        border-bottom: 1px solid var(--border-color);
      }

      .cell_job-button {
        padding: 0.875rem 0;
      }

      .cell_job-id {
        display: flex;
        align-items: start;

        & > a {
          margin-bottom: 0 !important;
        }

        & > span {
          max-width: max-content;
        }
      }

      .cell_job-button {
        grid-column: 2;
        grid-row: 1;
      }

      .cell_job-id {
        grid-row: 1;
      }

      .cell_time-job {
        display: flex !important;
        align-items: start;

        & div:first-child {
          & > * {
            margin: 0;
          }
        }
      }

      .cell_job-initiator {
        display: flex !important;
        align-items: start;
        gap: 0;

        & div:first-child {
          gap: 0 !important;
          max-width: 31vw;

          & div:first-child {
            padding-right: 0.25rem;
          }

          & div:last-child {
            overflow: hidden;
            text-wrap: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .cell_job-commit {
        display: flex !important;
        align-items: start;

        & div:first-child div:first-child span {
          max-width: 15vw;
        }

        & div:first-child div:last-child .pipeline-list-item__commit {
          display: block !important;
          max-width: 31vw;
        }
      }

      .cell_job-stages {
        display: flex !important;
        align-items: start;
      }
    }

    &.--header {
      background-color: var(--light);
      border-top-left-radius: var(--border-radius);
      border-top-right-radius: var(--border-radius);

      @media screen and (max-width: #{$break_lg}) {
        display: none;
      }
    }

    &:first-child > * {
      font-weight: 550;
      letter-spacing: 0.015rem;
    }
  }
  #{$this}__cell {
    @media screen and (min-width: #{$break_lg}) {
      padding: 0.875rem;

      &:last-child {
        padding: 0.875rem 0;
      }
    }

    @media screen and (max-width: #{$break_lg}) {
      display: grid;
      grid-template-columns: 1fr auto;
      grid-template-rows: auto;
      width: 100%;
      padding: 0.875rem 0;

      grid-column: 1 / span 2;

      &::before {
        width: 40%;
        text-align: left;
        overflow-wrap: break-word;
        font-weight: 550;
        letter-spacing: 0.015rem;
        font-style: normal;
        padding: 0 calc(1rem / 2) 0 0;
        margin: 0;
        content: attr(data-column);
      }
    }
  }
}
</style>
